<!-- Begin Footer (Do Not Touch) -->
<footer>
  <div class="container-fluid" style="margin: 0; display: flex; align-items: center; width: 100%; ">
    <div style="display: flex; align-items: center; width: 96%; margin: 0 auto; max-width: 1920px;">
      <div class="flex shrink">
        <a href="http://www.medpt.com" target="_blank" rel="noreferrer"><img src="{{cdnEndPoint}}/medpointapps/img/medpoint logo.svg" /></a>
      </div>
      <div class="justify-end flex-grow-1">
        <p><a href="javascript:void(0);" [routerLink]="['./Privacy']">Privacy</a>&emsp;|&emsp;<a href="javascript:void(0);" [routerLink]="['./Terms']">Terms of Use</a></p>
        <p class="small">Copyright {{currentYear}} MedPoint Digital, Inc. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</footer>
<!-- End Footer -->
